import {RootState} from '../reducers';
import * as disease from '../reducers/disease';

export const getDiseaseImagesSelector = (state: Pick<RootState, 'disease'>) => disease.getDiseaseImagesSelector(state.disease);
export const diseaseImagesSelector = (state: Pick<RootState, 'disease'>) => disease.diseaseImagesSelector(state.disease);
export const diseaseActiveFarmSelector = (state: Pick<RootState, 'disease'>) => disease.diseaseActiveFarmSelector(state.disease);
export const diseaseSelectedDateSelector = (state: Pick<RootState, 'disease'>) => disease.diseaseSelectedDateSelector(state.disease);
